export default "__VITE_ASSET__3fe20627__"